<template>
    <div class="signature" style="margin-top: 20px" :style="{ border: valid === false ? '1px solid #FF0000FF' : '' }">
        <vue-signature-pad
            v-if="!isDisabled"
            id="signature"
            ref="signaturePad"
            class="signature__pad"
            width="100%"
            height="100px"
        ></vue-signature-pad>
        <div v-else>
            <img v-if="signature" width="100%" :src="signature" alt="signature" class="signature__image" />
        </div>
        <div v-if="!signature" class="d-flex justify-content-between signature-info">
            <span :class="{ 'text-danger': valid === false }">Please fill the signature field {{ valid }}</span>
            <a v-if="!isDisabled" text color="primary" @click="clear"> Clear </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        formType: {
            type: String,
            required: true,
            default: '',
        },
        signatureField: {
            type: String,
            required: false,
            default: 'signature',
        },
        isDisabled: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            valid: null,
        };
    },
    computed: {
        signature: {
            get() {
                return _.get(this.$store.state['secure_sign_forms'], `${this.formType}.${this.signatureField}`);
            },
        },
    },
    watch: {
        signature() {
            this.$nextTick(() => {
                if (this.$refs.signaturePad) {
                    this.$refs.signaturePad.fromDataURL(this.signature);
                }
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.isDisabled && this.$refs.signaturePad) {
                this.$refs.signaturePad.lockSignaturePad();
            }
        });
    },
    methods: {
        clear() {
            this.$refs.signaturePad.undoSignature();
        },
    },
};
</script>

<style scoped></style>
